/* eslint-disable no-console */
import {ScriptStatus} from "./ScriptStatus";

export function newStatusPromise(
  script: HTMLScriptElement
): Promise<ScriptStatus> {
  return new Promise<ScriptStatus>(resolve => {
    script.addEventListener("error", (event: Event) => {
      console.warn(`Script ${script.id} failed to load`);
      event.preventDefault();
      resolve(ScriptStatus.FAILED);
    });
    script.addEventListener("load", (event: Event) => {
      console.info(`Script ${script.id} was loaded`);
      event.preventDefault();
      resolve(ScriptStatus.LOADED);
    });
  });
}
